import { render, staticRenderFns } from "./SafetyList.vue?vue&type=template&id=162e000e&scoped=true&"
import script from "./SafetyList.vue?vue&type=script&lang=js&"
export * from "./SafetyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162e000e",
  null
  
)

export default component.exports